import {FeedItem, NewIcalFeed, Feed} from './types'
import {IcalFeedsManagerProps} from './IcalFeedsManager'
import {getCsrfToken} from '../../utils/csrf'

export const defaultHeaders = new Headers({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-CSRF-Token': getCsrfToken()
})

export async function getFeeds(props:IcalFeedsManagerProps):Promise<Feed[]> {
  const result = await fetch(props.base_url, {
    method: "GET",
    credentials: 'same-origin',
    headers: defaultHeaders
  })

  return await result.json() as Feed[]
}

type ErrorMessages = {
  [key: string]: string[]
}

export type createResult = {
  success:boolean
  messages: ErrorMessages
  feed:Feed
}

export type SyncResult = {
  status: "ok"
  feed: Feed
} | {
  status: "error"
  error: string
}

export async function createFeed(props:IcalFeedsManagerProps, feed:NewIcalFeed):Promise<createResult> {
  const ret = await fetch(props.base_url, {
    method: "POST",
    credentials: "same-origin",
    headers: defaultHeaders,
    body: JSON.stringify({feed: feed})
  });
  return await ret.json();
}

export async function removeFeed(props:IcalFeedsManagerProps, feed:Feed):Promise<any> {
  const ret = await fetch(`${props.base_url}/${feed.id}`, {
    method: "DELETE",
    credentials: "same-origin",
    headers: defaultHeaders
  });
  return await ret.json();
}

export async function syncFeed(props:IcalFeedsManagerProps, feed:Feed):Promise<SyncResult> {
  const ret = await fetch(`${props.base_url}/${feed.id}/sync`, {
    method: "POST",
    credentials: "same-origin",
    headers: defaultHeaders
  });
  return await ret.json();
}
